"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Messages = require("../codegen/Messages");
var React = require("react");
var react_1 = require("@fluentui/react");
var helper_1 = require("../utils/helper");
var types_1 = require("../context/types");
var constants_1 = require("../constants/constants");
var ActionsCard = function (_a) {
    var countryCode = _a.countryCode, region = _a.region, tenant = _a.tenant, domain = _a.domain, tenancySubscription = _a.tenancySubscription;
    var isPromoExpired = (tenancySubscription === null || tenancySubscription === void 0 ? void 0 : tenancySubscription.type) === types_1.TenancySubscriptionTypeEnum.PROMO_EXPIRED;
    var isChildTenancy = (tenancySubscription === null || tenancySubscription === void 0 ? void 0 : tenancySubscription.organizationType) ===
        types_1.TenancySubscriptionOrganizationTypeEnum.CHILD;
    var cardClass = tenancySubscription && isPromoExpired && !isChildTenancy
        ? "card-item-2-col"
        : "card-item-3-col";
    var INVOICE_PAGE_URL = helper_1.genOCIRedirectURL(constants_1.ORACLE_CLOUD_BASE_PATH + "/invoices-and-orders/invoices", region, tenant, domain);
    var COST_ANALYSIS_PAGE_URL = helper_1.genOCIRedirectURL(constants_1.ORACLE_CLOUD_BASE_PATH + "/account-management/cost-analysis", region, tenant, domain);
    var UPGRADE_PAGE_URL = helper_1.genOCIRedirectURL(constants_1.ORACLE_CLOUD_BASE_PATH + "/invoices-and-orders/upgrade-and-payment", region, tenant, domain);
    var getExternalLinkIcon = React.useCallback(function () {
        var iconClass = react_1.mergeStyles({
            height: 10,
            width: 10,
        });
        return (React.createElement(react_1.FontIcon, { "aria-label": "ExternalLink", iconName: "NavigateExternalInline", className: iconClass }));
    }, []);
    var getSalesChatPageUrl = React.useCallback(function () {
        var country = countryCode === null || countryCode === void 0 ? void 0 : countryCode.toLowerCase();
        var url = "https://www.oracle.com/corporate/contact/global.html";
        if (country === "us") {
            url = "https://www.oracle.com/corporate/contact/";
        }
        else if (country === "ca") {
            url = url = "https://www.oracle.com/ca-en/corporate/contact/";
        }
        else if (country === "ch") {
            url = "https://www.oracle.com/ch-de/corporate/contact/";
        }
        else if (constants_1.LOCALIZED_COUNTRIES.some(function (c) { return c === country; })) {
            url = "https://www.oracle.com/" + country + "/corporate/contact/";
        }
        return url;
    }, [countryCode]);
    return (React.createElement("div", { className: cardClass },
        React.createElement(react_1.DocumentCard, { className: "card" },
            React.createElement("h3", null, Messages.costManagementWidget.ActionsTitle()),
            React.createElement(react_1.Link, { href: COST_ANALYSIS_PAGE_URL, target: "_blank" },
                React.createElement("span", null, Messages.costManagementWidget.viewCostAnalysis()),
                getExternalLinkIcon()),
            React.createElement(react_1.Link, { href: UPGRADE_PAGE_URL, target: "_blank" },
                React.createElement("span", null, Messages.costManagementWidget.managePaymentMethod()),
                getExternalLinkIcon()),
            React.createElement(react_1.Link, { href: INVOICE_PAGE_URL, target: "_blank" },
                React.createElement("span", null, Messages.costManagementWidget.viewInvoices()),
                getExternalLinkIcon()),
            React.createElement(react_1.Link, { href: getSalesChatPageUrl(), target: "_blank" },
                React.createElement("span", null, Messages.costManagementWidget.requestSalesCall()),
                getExternalLinkIcon()))));
};
exports.default = ActionsCard;
//# sourceMappingURL=ActionsCard.js.map